import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import { Button }                                   from "semantic-ui-react";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import LeftPositionSection                          from "../../components/common/layout/LeftPositionSection";
import RightPositionSection                         from "../../components/common/layout/RightPositionSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import OfficeSelector                               from "../../components/common/OfficeSelector";
import ReservationCancelRequestTransitionButton
                                                    from "../../components/reservation/history/ReservationCancelRequestTransitionButton";
import ReservationCounter                           from "../../components/reservation/ReservationCounter";
import ReservationCustomerSelector                  from "../../components/reservation/ReservationCustomerSelector";
import ReservationPlanSelector                      from "../../components/reservation/ReservationPlanSelector";
import ReservationStaffSelector                     from "../../components/reservation/ReservationStaffSelector";
import ReservationTimeTable                         from "../../components/reservation/ReservationTimeTable";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

class ReservationContainer extends ResKaBaseContainer<BaseProps, BaseState> {
  constructor(props: BaseProps) {
    const state: BaseState = {
      headerTitle: "予約管理",
      menuType: MenuType.RESERVATION,
    };
    super(props, state);
  }

  protected componentDidMountInternal(): void {
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <LeftPositionSection style={ {marginBottom: "1rem"} }>
          <section style={ {marginRight: "1rem", paddingTop: "0.5rem"} }>
            <ReservationCounter/>
          </section>
          <section style={ {width: "100%"} }>
            <ReservationCancelRequestTransitionButton/>
          </section>

          <RightPositionSection>
            <OfficeSelector/>
          </RightPositionSection>
        </LeftPositionSection>

        <TopSection>
          <ReservationCustomerSelector/>
          <ReservationStaffSelector/>
          <ReservationPlanSelector/>
        </TopSection>

        <ReservationTimeTable/>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

export default connect(mapStateToProps)(ReservationContainer);
